import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { FormsModule, ReactiveFormsModule, UntypedFormGroup } from "@angular/forms";
import { InputNumberComponent } from "@components/input-number/input-number.component";
import { TableKeyboardNavigationDirective } from "../../../../../common/directives/table-keyboard-navigation/table-keyboard-navigation.directive";

@Component({
    selector: "rask-kontrakt-gruppering",
    templateUrl: "./kontrakt-gruppering.component.html",
    styleUrls: ["./kontrakt-gruppering.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        TableKeyboardNavigationDirective,
        FormsModule,
        ReactiveFormsModule,
        InputNumberComponent
    ]
})
export class KontraktGrupperingComponent {
    @Input() formGroup: UntypedFormGroup;
}
